export enum PopupWhenTypeEnum {
  Again = 1,
  JustOne = 2,
}
